@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.cardWrapper {
  padding: 12px;
  background-color: var(--surface-default);
  display: flex;
  justify-content: space-between;
  gap: 16px;

  &:first-child {
    border-top-left-radius: border-radius(r2);
    border-top-right-radius: border-radius(r2);
  }

  &:last-child {
    border-bottom-left-radius: border-radius(r2);
    border-bottom-right-radius: border-radius(r2);
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--border-soft);
  }
}

.favicon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  flex: 1;
  min-width: 0;

  &.onlyUrl {
    align-items: center;
  }
}

.infoWrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.title {
  @include typography-v2-body-base;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.url {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}